import enviro from 'enviro';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { Data } from '../signup-data/DATA';
import { codeVerificationStart } from '../store/step-code-verification/action-creators';
import { CodeVerificationActionTypes } from '../store/step-code-verification/action-types';
import { WaveType } from '../wave/Wave';
import { Step } from './Step';
import { StepConfigFactory } from './StepConfigFactory';
import { getStepView } from './StepViews';
export const StepConfigs = new Map(); // ----------
// Registration of error steps
// ----------

export const errorSteps = [Step.EmailVerificationNotFound, Step.InternalError, Step.LoginFailed, Step.StandardCreationError, Step.VerifyFirstCreationError, Step.RateLimitedCreationError, Step.OAuthExistingLoginFailed, Step.OAuthPendingEmailVerification, Step.RateLimitedEmailVerification, Step.EmailVerificationFailed, Step.SessionExpired, Step.ExistingAccountsFetchFailed, Step.RecaptchaCreationError, Step.PartnerExistingAccountError, Step.AlreadyAPartner, Step.WordpressAuthorizationError, Step.BlankScreenLoadingError, Step.PartnerNoRegisteredLeads, Step.NoPartnerPortalsError, Step.EmbeddedSignupContinueScreen, Step.RecaptchaMissingInformationError];
errorSteps.forEach(errorStep => StepConfigs.set(errorStep, StepConfigFactory.getStepConfig(errorStep, [], getStepView(errorStep), {
  hideBackButton: true,
  isWideStep: true,
  waveType: WaveType.Error,
  isFramedCentredStep: false
}))); // ----------
// Registration of singular steps
// ----------

StepConfigs.set(Step.LandingPage, StepConfigFactory.getStepConfig(Step.LandingPage, [Data.Email], getStepView(Step.LandingPage), {
  hideStepNumber: true,
  hideProgressBar: true,
  shouldShowPrivacyBanner: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.Name, StepConfigFactory.getStepConfig(Step.Name, [Data.FirstName, Data.LastName], getStepView(Step.Name), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.Industry, StepConfigFactory.getStepConfig(Step.Industry, [Data.Industry], getStepView(Step.Industry), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.JobRole, StepConfigFactory.getStepConfig(Step.JobRole, [Data.JobRole], getStepView(Step.JobRole), {
  trackSelectedOption: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.ManagementLevel, StepConfigFactory.getStepConfig(Step.ManagementLevel, [Data.ManagementLevel], getStepView(Step.ManagementLevel), {
  trackSelectedOption: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.Verification, StepConfigFactory.getStepConfig(Step.Verification, [Data.Verification], getStepView(Step.Verification), {
  hideBackButton: true,
  shouldStepUseLayoutTemplate: true,
  showMessagingAboveContent: true
}));
StepConfigs.set(Step.UnauthedPartnerUserError, StepConfigFactory.getStepConfig(Step.UnauthedPartnerUserError, [], getStepView(Step.UnauthedPartnerUserError), {
  hideBackButton: true,
  hideProgressBar: true,
  isWideStep: true,
  waveType: WaveType.Error,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.ResendEmail, StepConfigFactory.getStepConfig(Step.ResendEmail, [Data.Email], getStepView(Step.ResendEmail), {
  shouldStepUseLayoutTemplate: true,
  showMessagingAboveContent: true
}));
StepConfigs.set(Step.Password, StepConfigFactory.getStepConfig(Step.Password, [Data.Password], getStepView(Step.Password), {
  hideBackButton: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.MobileAppPrompt, StepConfigFactory.getStepConfig(Step.MobileAppPrompt, [], getStepView(Step.MobileAppPrompt), {
  hideBackButton: true,
  isWideStep: true,
  waveType: WaveType.Step,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.ExistingUser, StepConfigFactory.getStepConfig(Step.ExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.ExistingUser), {
  hideProgressBar: true,
  hideBackButton: true,
  isWideStep: true,
  waveType: WaveType.Step,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.ExistingAccounts, StepConfigFactory.getStepConfig(Step.ExistingAccounts, [], getStepView(Step.ExistingAccounts), {
  hideProgressBar: true,
  isWideStep: true,
  waveType: WaveType.Step,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.HublessNoAccount, StepConfigFactory.getStepConfig(Step.HublessNoAccount, [], getStepView(Step.HublessNoAccount), {
  hideProgressBar: true,
  isWideStep: true,
  waveType: WaveType.Error,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.FirstName, StepConfigFactory.getStepConfig(Step.FirstName, [Data.FirstName], getStepView(Step.FirstName)));
StepConfigs.set(Step.LastName, StepConfigFactory.getStepConfig(Step.LastName, [Data.LastName], getStepView(Step.LastName)));
StepConfigs.set(Step.CompanyDomain, StepConfigFactory.getStepConfig(Step.CompanyDomain, [Data.CompanyDomain], getStepView(Step.CompanyDomain), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.CompanyName, StepConfigFactory.getStepConfig(Step.CompanyName, [Data.CompanyName], getStepView(Step.CompanyName), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.CompanyDomain], getStepView(Step.IntegrationsAccountCreated), {
  hideBackButton: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.WordpressAuthorization, StepConfigFactory.getStepConfig(Step.WordpressAuthorization, [Data.WordpressRecaptchaToken], getStepView(Step.WordpressAuthorization), {
  hideBackButton: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.CodeVerification, Object.assign({}, StepConfigFactory.getStepConfig(Step.CodeVerification, [Data.CodeVerification], getStepView(Step.CodeVerification), {
  showMessagingAboveContent: true,
  hideBackButton: true,
  shouldStepUseLayoutTemplate: true
}), {
  beforeComplete: dispatch => dispatch(codeVerificationStart()),
  stepCompletedAction: CodeVerificationActionTypes.Success
}));
StepConfigs.set(Step.HubInterest, StepConfigFactory.getStepConfig(Step.HubInterest, [Data.HubInterest], getStepView(Step.HubInterest), {
  trackSelectedOption: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.AcademyEmbeddedExistingUser, StepConfigFactory.getStepConfig(Step.AcademyEmbeddedExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.AcademyEmbeddedExistingUser), {
  trackSelectedOption: true,
  isWideStep: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.HubletSelection, StepConfigFactory.getStepConfig(Step.HubletSelection, [Data.HubletSelection], getStepView(Step.HubletSelection), {
  trackSelectedOption: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.Country, StepConfigFactory.getStepConfig(Step.Country, [Data.Country], getStepView(Step.Country), {
  trackSelectedOption: true
}));
StepConfigs.set(Step.PhoneNumber, StepConfigFactory.getStepConfig(Step.PhoneNumber, [Data.PhoneNumber], getStepView(Step.PhoneNumber)));
StepConfigs.set(Step.CmsPartnerCompanyDomainAndName, StepConfigFactory.getStepConfig(Step.CmsPartnerCompanyDomainAndName, [Data.CompanyDomain, Data.CompanyName], getStepView(Step.CmsPartnerCompanyDomainAndName)));
StepConfigs.set(Step.OptionalPhoneNumber, StepConfigFactory.getStepConfig(Step.OptionalPhoneNumber, [Data.OptionalPhoneNumber], getStepView(Step.OptionalPhoneNumber), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.CmsExistingUser, StepConfigFactory.getStepConfig(Step.CmsExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.CmsExistingUser), {
  hideProgressBar: true,
  hideBackButton: true,
  isWideStep: true,
  waveType: WaveType.Step,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.IntegrationsAccountCreatedCheck], getStepView(Step.IntegrationsAccountCreated), {
  hideBackButton: true,
  isWideStep: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.InstallSalesExtension, StepConfigFactory.getStepConfig(Step.InstallSalesExtension, [Data.InstallSalesExtension], getStepView(Step.InstallSalesExtension), {
  isWideStep: true,
  waveType: WaveType.PostAccountCreation,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.BusinessBox, StepConfigFactory.getStepConfig(Step.BusinessBox, [Data.BusinessBox], getStepView(Step.BusinessBox), {
  isFramedCentredStep: false,
  trackSelectedOption: true
}));
StepConfigs.set(Step.CompanySize, StepConfigFactory.getStepConfig(Step.CompanySize, [Data.CompanySize], getStepView(Step.CompanySize), {
  trackSelectedOption: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.CrmExperienceLevel, StepConfigFactory.getStepConfig(Step.CrmExperienceLevel, [Data.CrmExperienceLevel], getStepView(Step.CrmExperienceLevel), {
  trackSelectedOption: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.JobField, StepConfigFactory.getStepConfig(Step.JobField, [Data.JobField], getStepView(Step.JobField), {
  trackSelectedOption: true,
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.CmsSignupIntent, StepConfigFactory.getStepConfig(Step.CmsSignupIntent, [Data.CmsSignupIntent], getStepView(Step.CmsSignupIntent), {
  trackSelectedOption: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.CmsBusinessMaturity, StepConfigFactory.getStepConfig(Step.CmsBusinessMaturity, [Data.CmsBusinessMaturity], getStepView(Step.CmsBusinessMaturity), {
  trackSelectedOption: true,
  isFramedCentredStep: false
}));
StepConfigs.set(Step.GoogleContactsSync, StepConfigFactory.getStepConfig(Step.GoogleContactsSync, [Data.GoogleAccountId], getStepView(Step.GoogleContactsSync)));
StepConfigs.set(Step.CompanyInfo, StepConfigFactory.getStepConfig(Step.CompanyInfo, [Data.CompanyName, Data.CompanyDomain], getStepView(Step.CompanyInfo), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.CompanyDetails, StepConfigFactory.getStepConfig(Step.CompanyDetails, [Data.CompanyName, Data.CompanyDomain], getStepView(Step.CompanyDetails), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.HubOption, StepConfigFactory.getStepConfig(Step.HubOption, [Data.HubOption], getStepView(Step.HubOption), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.BusinessGoals, StepConfigFactory.getStepConfig(Step.BusinessGoals, [Data.BusinessGoals], getStepView(Step.BusinessGoals), {
  shouldStepUseLayoutTemplate: true
}));
StepConfigs.set(Step.AhaMoment, StepConfigFactory.getStepConfig(Step.AhaMoment, [], getStepView(Step.AhaMoment), {
  shouldStepUseLayoutTemplate: true
})); // Local development information

if (enviro.isQa() && !enviro.deployed()) {
  const allSteps = Object.values(Step);
  const registeredSteps = Array.from(StepConfigs.keys());
  const allDataAndError = [...Object.values(Data), ...Object.values(ErrorKey)];
  const notIncludedInConfig = allDataAndError.filter(x => !registeredSteps.includes(x));
  const notRegistered = allSteps.filter(x => !registeredSteps.includes(x));
  /* eslint-disable no-console */

  console.group('StepConfigs Debug Information');
  console.info(`Data points or error keys not included as a step config`, notIncludedInConfig);
  console.info(`Steps not registered`, notRegistered);
  console.groupEnd();
}